module.exports = __webpack_public_path__ + "static/media/feeling_stressed.3f60be06.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/feeling_stressed.svg
// module id = 1956
// module chunks = 71